export default __webpack_public_path__ + "static/media/Home.433f96e4.svg";